
// 预算调整明细详情
export const listColumnData = [
    { label: "流程编号", prop: "applyCode", align: "center", width: '150' },
    { label: "流程标题", prop: "title", align: "center", width: '150', type: "CUSTOM" },
    { label: "期待完成时间", prop: "expectedCompletionDate", align: "center", width: '120', type: "CUSTOM" },
    { label: "紧急程度", prop: "ext3", align: "center", type: "CUSTOM" },
    { label: "申请时间", prop: "applyTime", align: "center", width: '180', type: "CUSTOM" },
    { label: "申请人", prop: "userName", align: "center" },
    { label: "申请人部门", prop: "firstDeptName", width: '150', align: "center" },
    { label: "流程状态", prop: "status", width: '150', align: "center" },
    { label: "操作", prop: "operation", align: "center", type: "CUSTOM", fixed: 'right' },
]
export const addDetailColumnData = [
    { label: "费用归属一级部门", prop: "firstDeptId", align: "center", width: '200', type: "CUSTOM" },
    { label: "预算大类", prop: "subjectsCatId", align: "center", width: '170', type: "CUSTOM" },
    { label: "预算类型", prop: "subjectsTypeId", align: "center", width: '170', type: "CUSTOM" },
    { label: "年份", prop: "year", align: "center", width: '130', type: "CUSTOM" },
    { label: "月份", prop: "month", align: "center", width: '130', type: "CUSTOM" },
    { label: "调整金额", prop: "adjustAmount", align: "center", width: '170', type: 'CUSTOM' },
    { label: "年初预算金额", prop: "budgetAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "调整后半年度预算金额", prop: "adjustBeforeAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算已执行金额", prop: "budgetImplementedAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算已冻结金额", prop: "freezeAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "调整后剩余金额", prop: "adjustAfterRemainAmount", align: "center", width: '170', type: 'MONEY2' },
]
// V3.6.2 相同预算大类/相同一级部门/预算外调整共用列配置（ext1=2/5 等）
// 变更：隐藏「事业部」，在原位置新增「是否待分摊」必填下拉
export const sameBudgetTypeColumnData = [
    { label: "预算一级部门", prop: "firstDeptId", align: "center", width: '200', type: "CUSTOM" },
    { label: "预算大类", prop: "subjectsCatId", align: "center", width: '170', type: "CUSTOM" },
    { label: "预算类型", prop: "subjectsTypeId", align: "center", width: '170', type: "CUSTOM" },
    { label: "是否待分摊", prop: "shareTypeNo", align: "center", width: '170', type: "CUSTOM" },
    { label: "预算周期", prop: "cycleMonth", align: "center", width: '150', type: "CUSTOM" },
    { label: "调整金额（+增-减）", prop: "adjustAmount", align: "center", width: '170', type: 'CUSTOM' },
    { label: "预算编制金额", prop: "budgetAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算已调整金额", prop: "adjustBeforeAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算已执行金额", prop: "budgetImplementedAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算已冻结金额", prop: "freezeAmount", align: "center", width: '170', type: 'MONEY2' },
    // TODO ADD
    { label: "预算剩余金额", prop: "remainAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "调整后预算剩余金额", prop: "adjustAfterRemainAmount", align: "center", width: '170', type: 'MONEY2' },
    // TODO ADD
    { label: "操作", prop: "operate", align: "center", width: '130', type: 'CUSTOM', fixed: 'right' },
]
export const detailColumnData = [
    { label: "费用归属一级部门", prop: "firstDeptName", align: "center", width: '200' },
    { label: "预算大类", prop: "subjectsCatName", align: "center", width: '150' },
    { label: "预算类型", prop: "subjectsTypeName", align: "center", width: '150' },
    { label: "年份", prop: "year", align: "center", width: '80' },
    { label: "月份", prop: "month", align: "center", width: '80' },
    { label: "调整金额", prop: "adjustAmount", align: "center", width: '150', type: 'MONEY2' },
    // TODO 不该展示，留作数据
    { label: "年初预算金额", prop: "budgetAmount", align: "center", width: '150', type: 'MONEY2' },
    { label: "调整后半年度预算金额", prop: "adjustBeforeAmount", align: "center", width: '160', type: 'MONEY2' },
    { label: "预算已执行金额", prop: "budgetImplementedAmount", align: "center", width: '150', type: 'MONEY2' },
    { label: "预算已冻结金额", prop: "freezeAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "调整后剩余金额", prop: "adjustAfterRemainAmount", align: "center", width: '150', type: 'MONEY2' },
]
// V3.6.2 调整详情列：历史 ext1=1/3 流程仍展示「事业部」；新流程 ext1=2/5 在 detail.vue 中过滤掉事业部列
export const extType1DetailColumnData = [ // 相同预算大类 / 相同一级部门 / 预算外
    { label: "预算一级部门", prop: "firstDeptName", align: "center", width: '130', },
    { label: "预算大类", prop: "subjectsCatName", align: "center", width: '130', },
    { label: "预算类型", prop: "subjectsTypeName", align: "center", width: '120', },
    { label: "事业部", prop: "businessUnitName", align: "center", width: '120', }, // 历史数据保留
    { label: "是否待分摊", prop: "shareType", align: "center", width: '120', },
    { label: "预算周期", prop: "month", align: "center", width: '120', },
    { label: "调整金额（+增-减）", prop: "adjustAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算编制金额", prop: "budgetAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算已调整金额", prop: "adjustBeforeAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算已执行金额", prop: "budgetImplementedAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算已冻结金额", prop: "freezeAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "预算剩余金额", prop: "remainAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "调整后预算剩余金额", prop: "adjustAfterRemainAmount", align: "center", width: '170', type: 'MONEY2' },
]


export const elasticityColumnData = [ // 弹性授予调整
    { label: "预算一级部门", prop: "firstDeptId", align: "center", width: '200', type: "CUSTOM" },
    { label: "预算大类", prop: "subjectsCatId", align: "center", width: '170', type: "CUSTOM" },
    { label: "预算类型", prop: "subjectsTypeId", align: "center", width: '170', type: "CUSTOM" },
    { label: "事业部", prop: "businessUnitId", align: "center", width: '170', type: "CUSTOM" },
    { label: "预算周期", prop: "budgetCycle", align: "center", width: '200', type: "CUSTOM" },
    //  已授予金额 ok
    { label: "已授予金额", prop: "grantedAmount", align: "center", width: '150', type: 'MONEY2' },
    //  已授予调整月份 ok
    { label: "已授予调整月份", prop: "grantedMonth", align: "center", width: '170', type: "CUSTOM" },
    //  已授予调整金额（+增-减） ok
    { label: "已授予调整金额（+增-减）", prop: "adjustGrantedAmount", align: "center", width: '200', type: 'CUSTOM' },
    // { label: "预算编制金额", prop: "budgetAmount", align: "center", width: '170' , type: 'MONEY2'},
    //  已授予调整后金额 ok
    { label: "已授予调整后金额", prop: "afterGrantedAmount", align: "center", width: '170', type: 'MONEY2' },
    //  待授予金额
    { label: "待授予金额", prop: "pendingGrantedAmount", align: "center", width: '170', type: 'MONEY2' },
    //  待授予调整月份 ok
    { label: "待授予调整月份", prop: "pendingGrantedMonth", align: "center", width: '170', type: 'CUSTOM' },
    //  待授予调整金额（+增-减）ok
    { label: "待授予调整金额（+增-减）", prop: "adjustPendingGrantedAmount", align: "center", width: '200', type: 'CUSTOM' },
    //  待授予调整后金额
    { label: "待授予调整后金额", prop: "afterPendingGrantedAmount", align: "center", width: '170', type: 'MONEY2' },
    { label: "操作", prop: "operate", align: "center", width: '130', type: 'CUSTOM', fixed: 'right' },
]

export const elasticityColumnDataByDetail = [ // 弹性授予调整
    { label: "预算一级部门", prop: "firstDeptName", align: "center", width: '200' },
    { label: "预算大类", prop: "subjectsCatName", align: "center", width: '170', },
    { label: "预算类型", prop: "subjectsTypeName", align: "center", width: '170' },
    // 查看下是不是没传bussineseename
    { label: "事业部", prop: "businessUnitName", align: "center", width: '170' },
    { label: "预算周期", prop: "budgetCycle", align: "center", width: '200' },
    //  已授予金额 ok
    { label: "已授予金额", prop: "grantedAmount", align: "center", width: '150', type: 'MONEY2' },
    //  已授予调整月份 ok
    { label: "已授予调整月份", prop: "grantedMonth", align: "center", width: '170' },
    //  已授予调整金额（+增-减） ok
    { label: "已授予调整金额（+增-减）", prop: "adjustGrantedAmount", align: "center", width: '200', type: 'MONEY2' },
    // { label: "预算编制金额", prop: "budgetAmount", align: "center", width: '170' , type: 'MONEY2'},
    //  已授予调整后金额 ok
    { label: "已授予调整后金额", prop: "afterGrantedAmount", align: "center", width: '170', type: 'MONEY2' },
    //  待授予金额
    { label: "待授予金额", prop: "pendingGrantedAmount", align: "center", width: '170', type: 'MONEY2' },
    //  待授予调整月份 ok
    { label: "待授予调整月份", prop: "pendingGrantedMonth", align: "center", width: '170' },
    //  待授予调整金额（+增-减）ok
    { label: "待授予调整金额（+增-减）", prop: "adjustPendingGrantedAmount", align: "center", width: '200', type: 'MONEY2' },
    //  待授予调整后金额
    { label: "待授予调整后金额", prop: "afterPendingGrantedAmount", align: "center", width: '170', type: 'MONEY2' },
]